import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function Proof() {
  return <section className="w-full bg-navy-900 px-4 py-20" data-id="element-138">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center" data-id="element-139">
        <div className="flex justify-center mb-6" data-id="element-140">
          <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-141">
            <SparklesIcon className="w-8 h-8 text-gold" data-id="element-142" />
          </div>
        </div>
        <h2 className="font-serif text-3xl md:text-4xl text-white mb-6" data-id="element-143">
          Resultados en 7 Días
        </h2>
        <div className="h-1 w-24 bg-gold mx-auto mb-8" data-id="element-144"></div>
        <div className="bg-navy-800/50 border border-gold/30 rounded-lg p-8 md:p-12" data-id="element-145">
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-146">
            En solo 7 días, tu sistema nervioso se reprograma. No solo dormirás
            más rápido, sino que la calidad de tu sueño será{' '}
            <span className="text-gold font-semibold" data-id="element-147">
              "pesada" y reparadora
            </span>
            . Dejarás de despertarte con esa sensación de "cerebro nublado" y
            recuperarás tu claridad mental desde la primera hora del día.
          </p>
        </div>
      </motion.div>
    </section>;
}